<template>
  <el-dialog
    :title="titleTrans"
    :visible.sync="centerDialogVisible"
    @close="handleClose"
  >
    <div
      class="form-content"
      style="width:70%;padding-left:20px;"
    >
      <el-form
        ref="dataInfo"
        :model="dataInfo"
        :rules="rules"
        label-width="180px"
      >
        <el-form-item
          v-if="isEdit"
          label="字典编号"
        >
          <span>{{ dataInfo.id }}</span>
        </el-form-item>
        <el-form-item
          label="字典名称"
          prop="name"
        >
          <el-input v-model="dataInfo.name" />
        </el-form-item>
        <el-form-item
          label="Key值"
          prop="dicKey"
        >
          <el-input
            v-if="!isEdit"
            v-model="dataInfo.dicKey"
          />
          <span
            v-if="isEdit"
            class="value"
          >{{ dataInfo.dicKey }}</span>
        </el-form-item>
        <el-form-item
          label="字典类型"
          prop="type"
        >
          <el-radio-group v-model="dataInfo.type">
            <el-radio :label="1">系统</el-radio>
            <el-radio :label="2">普通</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

    </div>
    <span
    slot="footer"
    class="dialog-footer"
  >
  <el-button @click="handleClose">取消</el-button>
  <el-button
    type="primary"
    style="margin-left:8px"
    @click="submitForm('dataInfo')"
  >确定</el-button>
  </span>
  </el-dialog>
</template>

<script>
import { addDic, dicDetail, validateDicKey } from '@/api/system'
export default {
  // props: ['editData','isEdit'],
  props: {
    editData: {
      default: {
      }
    },
    isedit: {
      default: 'false'
    }
  },
  data() {
    return {
      isEdit: this.isedit,
      dataInfo: this.editData,
      centerDialogVisible: true,
      type: '1',
      rules: {
        name: [
          { required: true, min: 1, max: 50, message: '请输入长度在 1到 50 个字符', trigger: 'blur' }
        ],
        dicKey: [{
          required: true,
          validator: this.checkoutCode,
          trigger: 'blur'
        }],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ]
      }

    }
  },
  computed: {
    titleTrans() {
      let result = '新增字典'
      if (this.isEdit) {
        result = '编辑字典'
      }
      return result
    }
  },
  mounted() {
    if (!this.dataInfo.type) {
      this.$set(this.dataInfo, 'type', 1)
    }
  },
  methods: {
    handleClose() {
      this.$emit('handleclose', null)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.dataInfo.type = this.type
          addDic(this.dataInfo).then(res => {
            if (res && res.code == 0) {
              // 刷新父级列表(接口成功回调处理)
              this.$emit('refresh', null)
              this.$emit('handleclose', null)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    checkoutCode(rule, value, callback) {
      const _data = {
        dicKey: this.dataInfo.dicKey
      }
      validateDicKey(_data).then(res => {
        if (res && res.code == 0) {
          if (value == '' || value == null || value == undefined) {
            callback('key值不能为空')
          } else if (value.length > 50) {
            callback(new Error('key值长度不能超过50'))
          } else if (res.data && !this.isEdit) {
            callback(new Error('key值不可以重复'))
          } else {
            callback()
          }
        }
      })
    }

  }
}
</script>
<style lang="scss" scoped>
.el-radio{
  margin-right:40px;
  width:40px;
}

</style>
